export const ALERT_ERROR = 'dialog--error';
export const ALERT_WARNING = 'dialog--warning';
export const ALERT_SUCCESS = 'dialog--success';
export const ALERT_INFO = 'dialog--info';

export type AlertType =
	| typeof ALERT_ERROR
	| typeof ALERT_WARNING
	| typeof ALERT_SUCCESS
	| typeof ALERT_INFO;

export enum AlertPosition {
	TopLeft = 'alert--top-left',
	TopCenter = 'alert--top-center',
	TopRight = 'alert--top-right',
	BottomLeft = 'alert--bottom-left',
	BottomCenter = 'alert--bottom-center',
	BottomRight = 'alert--bottom-right',
}
